/**
 * @generated SignedSource<<a8b1d1d10c96a727a9a31f63ff9b2d35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeniedPage_page$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly id: string;
  readonly path: string | null | undefined;
  readonly " $fragmentType": "DeniedPage_page";
};
export type DeniedPage_page$key = {
  readonly " $data"?: DeniedPage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeniedPage_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeniedPage_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Page",
  "abstractKey": "__isPage"
};

(node as any).hash = "89958e991c253a142e09b4d7eb53a356";

export default node;
